import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0177f75c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0177f75c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0177f75c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0177f75c')) {
      api.createRecord('0177f75c', component.options)
    } else {
      api.reload('0177f75c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0177f75c&scoped=true&", function () {
      api.rerender('0177f75c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tinymce/index.vue"
export default component.exports